import $ from 'jquery'
import { Util } from 'bootstrap'
import Alerts from './alerts'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'theme'
const DATA_KEY = `opp.${NAME}`
const EVENT_KEY = '.' + DATA_KEY
const DATA_API_KEY = '.data-api'
const JQUERY_NO_CONFLICT = $.fn[NAME]

const Default = {
  reload: false
}

const DefaultType = {
  reload: 'boolean',
  name: '(string|number)',
  title: '(string|number)'
}

const Selector = {
  DATA_TOGGLE: '[data-toggle="theme"]'
}

const Event = {
  CLICK_DATA_API: `click${EVENT_KEY}${DATA_API_KEY}`
}

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Theme {
  constructor(element, config) {
    this._config = this._getConfig(config)

    this._element = element
    this._document = (element && element.ownerDocument) || document
    this._supported = 'selectedStyleSheetSet' in this._document
  }

  // Public

  show() {
    const { reload, name, title } = this._config

    // Do nothing unless selection has changed. N.B. Using `==` instead of `===`
    // here because the `title` may be a string or a number.
    if (this._supported && title == this._document.selectedStyleSheetSet) { // eslint-disable-line eqeqeq
      return
    }

    // Update selected stylesheet unless we are going to reload.
    if (this._supported && !reload) {
      document.selectedStyleSheetSet = title
    }

    // Update settings.
    $.ajax({
      type: 'POST',
      url: 'cp_prefs',
      data: { theme: name },
      success: () => this._success(),
      error: () => this._error()
    })
  }

  // Private

  _getConfig(config) {
    config = {
      ...Default,
      ...config
    }
    Util.typeCheckConfig(NAME, config, DefaultType)
    return config
  }

  _success() {
    if (this._config.reload || !this._supported) {
      location.reload(true)
    }
  }

  _error() {
    Alerts.trigger(this._element, 'Failed to update theme', 'danger')
  }

  // Static

  static _jQueryInterface(config, ...args) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)
      const _config = {
        ...Default,
        ...$(this).data(),
        ...typeof config === 'object' && config ? config : {}
      }

      if (!data) {
        data = new Theme(this, _config)
        $(this).data(DATA_KEY, data)
      }

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`)
        }

        data[config](...args)
      }
    })
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

$(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
  event.preventDefault()
  Theme._jQueryInterface.call($(this), 'show')
})

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = Theme._jQueryInterface
$.fn[NAME].Constructor = Theme
$.fn[NAME].noConflict = () => {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return Theme._jQueryInterface
}

export default Theme
